import { SlideHeader, Headline, Body, CheckOrX } from "../shared";

export function Slide10Landscape() {
  const ROWS = [
    { label: "Bottles, sticks, sprays", worn: false, delivers: true, senses: false },
    { label: "UV sensing wearables", worn: true, delivers: false, senses: true },
    { label: "Smartwatch reminders", worn: true, delivers: false, senses: true },
    { label: "WearSpray today", worn: true, delivers: true, senses: false, highlight: true },
    { label: "WearSpray connected", worn: true, delivers: true, senses: true, highlight: true },
  ];
  return (
    <div className="max-w-5xl" data-testid="pitch-slide-landscape">
      <SlideHeader n="11" label="Landscape" />
      <div className="grid lg:grid-cols-2 gap-x-12 gap-y-6 items-start">
        <div>
          <Headline>
            The category is forming. <span className="text-accent">The action layer is missing.</span>
          </Headline>
          <Body>
            Bottles deliver but do not sense. Wearables sense but do not deliver. Apps recommend but
            do not deliver.
          </Body>
          <p className="font-heading text-white text-lg md:text-xl font-medium mt-2 max-w-2xl">
            WearSpray connects <span className="text-accent">intelligence with application.</span>
          </p>
          <p className="font-body text-zinc-500 text-sm leading-relaxed mt-4 max-w-2xl" data-testid="pitch-landscape-vertical">
            The same gap exists with a clinical audience: physicians personalize post-treatment
            routines, but have no way to deliver on adherence. <span className="text-white">Medical
            aesthetics &amp; dermatology</span> is an emerging vertical for the same action layer.
          </p>
        </div>
        <div className="border border-zinc-800 rounded-xl overflow-hidden" data-testid="pitch-landscape-table">
          <div className="flex items-center gap-2 px-5 py-3 border-b border-zinc-800 bg-white/[0.02]">
            <span className="font-mono text-[10px] tracking-[0.12em] uppercase text-zinc-500 flex-1">Category</span>
            <span className="font-mono text-[10px] tracking-[0.12em] uppercase text-zinc-500 w-14 sm:w-16 text-center">Worn</span>
            <span className="font-mono text-[10px] tracking-[0.12em] uppercase text-zinc-500 w-14 sm:w-16 text-center">Delivers</span>
            <span className="font-mono text-[10px] tracking-[0.12em] uppercase text-zinc-500 w-14 sm:w-16 text-center">Senses</span>
          </div>
          {ROWS.map((r) => (
            <div
              key={r.label}
              className={`flex items-center gap-2 px-5 py-3.5 border-b border-zinc-800/60 last:border-0 ${r.highlight ? "bg-accent/[0.06]" : ""}`}
              data-testid={`pitch-landscape-row-${r.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              <span className={`font-body text-sm flex-1 ${r.highlight ? "text-white font-medium" : "text-zinc-400"}`}>{r.label}</span>
              <CheckOrX ok={r.worn} />
              <CheckOrX ok={r.delivers} />
              <CheckOrX ok={r.senses} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
